export default "__VITE_ASSET__23ef6285__"